<template>
  <div class="goodsManagePage">
    <div class="banner">
      <img src="../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_item">辅助功能&内容管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">知识付费内容管理</div>
    </div>

    <div class="input_wrap flex-rowl">
      <div class="input_box search">
        <van-field
          v-model="params.keyword"
          ref="input"
          placeholder="关键词查找"
          @focus="handleFocus"
          @blur="handleBlur"
          @keyup.enter="handleSearch"
        />
      </div>
      <div class="primary-button" @click="handleSearch">查找→</div>
    </div>

    <div class="input_tip flex-rowc">
      <span>请查看搜索结果</span>
      <div class="btn" @click="handleSearch">显示全部</div>
    </div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div class="item_card" v-for="item in dataList" :key="item.id">
          <div class="img_box">
            <!-- <img :src="item.img" alt="" /> -->
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="item.cover"
            />
          </div>
          <div class="block">
            <p>内容所属系列：{{ item.typeidstr }}</p>
            <p>序号：{{ item.klno }}</p>
            <p>所属企业：{{ item.qyguidstr }}</p>
            <p>内容标签：{{ item.topic }}</p>
            <p>属性：{{ item.attrvalstr }}</p>
          </div>
          <div class="block">
            <p>内容收费价格：{{ item.price }}</p>
            <p>是否启用：{{ item.isuse }}</p>
            <p>发布时间：{{ item.publishdate | formatDate }}</p>
            <p>创建者：{{ item.creater }}</p>
          </div>
          <div class="editBtn" @click="handleGo(item.id, 'kManageDetail')">
            知识付费内容管理→
          </div>
        </div>
      </div>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleGo('', 'kBaseinfo')">
        新增知识付费内容
      </div>
    </div>
  </div>
</template>

<script>
import { getMenuAuthTwo, encryptstringadd } from "../../api/api";
import { getKonwledgeList } from "../../api/knowledge";
// import { getShopErcodeImg } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "kManageIndex",
  data() {
    return {
      isShowTabbar: true,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      isShow: false,
      loading: false,
      listTotal: 0,
      dataList: [],
      params: {
        qyguid: "",
        pageindex: 1,
        pagesize: 10,
        keyword: "",
      },

      dataItem: "", // 单个商品
      shopPopupImg: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  mounted() {
    this.initData(); // 初始化加载数据
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.params.qyguid = userInfo.qy.qyguid;
    this.roleId = userInfo.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    handleSearch() {
      this.params.pageindex = 1;
      this.initData();
    },
    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },

    initData() {
      let { params } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getKonwledgeList(params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },

    handleGo(id, name) {
      this.encryptstringadd(name, { id });
    },

    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.initData();
      }
    },

    handleReturn() {
      history.back();
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  padding-bottom: 420px;
  .input_wrap {
    padding: 20px 45px 30px;
    box-sizing: border-box;
    .primary-button {
      width: 145px;
      margin-left: 20px;
      font-size: 26px;
    }
  }
  .input_tip {
    font-size: 14px;
    margin-bottom: 60px;
    color: #aaaaaa;
    .btn {
      margin-left: 30px;
      background: #6e5c86;
      color: #fff;
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      border-radius: 5px;
    }
  }
  .main_content {
    width: 650px;
    margin: 60px auto 100px;
    .data_list {
      // padding-bottom: 320px;
      .item_card {
        border: 2px solid #dedede;
        border-radius: 30px;
        padding: 45px 37px 87px;
        box-sizing: border-box;
        font-size: 22px;
        color: #404d6c;
        position: relative;
        margin-bottom: 55px;
        .block {
          margin-bottom: 30px;
        }
        .img_box {
          width: 250px;
          height: 250px;
          margin: 35px auto;
          background: #f8f8f8;
          overflow: hidden;
        }
        h1 {
          font-size: 30px;
          color: #404d6c;
          margin-bottom: 12px;
        }
        p {
          margin-bottom: 10px;
        }
        .editBtn {
          width: 200px;
          height: 50px;
          background: #6e5c86;
          border-radius: 25px;
          text-align: center;
          line-height: 50px;
          font-size: 20px;
          color: #fff;
          position: absolute;
          right: 20px;
          bottom: 20px;
        }
      }
    }
  }
}
</style>